import React, { useCallback, useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import SimpleBar from "simplebar-react";
import MetisMenu from "metismenujs";
import withRouter from "../../components/Common/withRouter";
import { withTranslation } from "react-i18next";
import { useSelector } from "react-redux";

// Sidebar Data
const SidebarData = [
  {
    label: "OverView",
    icon: require("../../assets/images/icons/metrics.svg").ReactComponent,
    iconActive: require("../../assets/images/icons/metricsActive.svg").ReactComponent,
    url: "/dashboard",
    issubMenubadge: true,
  },
  {
    label: "Study Period Reports ",
    icon: require("../../assets/images/icons/teacherQC.svg").ReactComponent,
    iconActive: require("../../assets/images/icons/teacherQCActive.svg").ReactComponent,
    url: "settings",
    issubMenubadge: true,
    subItem: [
      { sublabel: "Study Period Overview", issubMenubadge: true, link: "/unitqc" },
      { sublabel: "Individual Unit Details", issubMenubadge: true, link: "/individalunitreport" },
      { sublabel: "Staff Overview", issubMenubadge: true, link: "/teacherqc" },
      { sublabel: "Individual Staff Details", issubMenubadge: true, link: "/individualteacher" },
    ]
  },
  {
    label: "Transcription",
    icon: require("../../assets/images/icons/transcription.svg").ReactComponent,
    iconActive: require("../../assets/images/icons/transcriptionActive.svg").ReactComponent,
    url: "/transcription",
    issubMenubadge: true,
  },
];

// Sidebar Component
const Sidebar = (props) => {
  const ref = useRef();
  const [activePath, setActivePath] = useState(props.router.location.pathname);
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const [isMobile, setIsMobile] = useState(false);
  const [openMenu, setOpenMenu] = useState({}); // Initialize as empty object

  // const userDetails = useSelector(state =>state.login.user);
  useEffect(() => {
    const role = localStorage.getItem('userpremission'); // only if it's a plain string
    console.log("role", role);
  }, [])
  const tabs = JSON.parse(localStorage.getItem("tabs"));

  //condition based menu show
  // const allowedTabs = JSON.parse(localStorage.getItem("tabs")) || [];

  // const isTabAllowed = (url) => {
  //   if (!url) return false;
  //   const path = url.replace("/", "");
  //   return allowedTabs.some(tab => tab.name === path);
  // };

  // const filteredSidebarData = SidebarData.map(item => {
  //   if (!isTabAllowed(item.url)) return null;

  //   const subItems = item.subItem?.filter(sub => isTabAllowed(sub.link)) || [];

  //   return {
  //     ...item,
  //     subItem: subItems.length ? subItems : undefined,
  //   };
  // }).filter(Boolean);

  // const role = localStorage.getItem("userpremission"); // assuming it's a string like "admin" or "user"
  // const allowedTabs = JSON.parse(localStorage.getItem("tabs")) || [];

  // const isTabAllowed = (url) => {
  //   if (!url) return false;
  //   const path = url.replace("/", "");
  //   return allowedTabs.some(tab => tab.name === path);
  // };

  // const filteredSidebarData = SidebarData.map(item => {
  //   if (role === "admin" || isTabAllowed(item.url)) {
  //     const subItems = item.subItem?.filter(sub => role === "admin" || isTabAllowed(sub.link)) || [];

  //     return {
  //       ...item,
  //       subItem: subItems.length ? subItems : undefined,
  //     };
  //   }
  //   return null;
  // }).filter(Boolean);


  const role = localStorage.getItem("userpremission");
const allowedTabs = JSON.parse(localStorage.getItem("tabs")) || [];

const isTabAllowed = (url) => {
  if (!url) return false;
  const path = url.replace("/", "");
  return allowedTabs.some(tab => tab.name === path);
};

const filteredSidebarData = SidebarData.map(item => {
  // Always include for admin
  if (role === "admin") return item;

  // Check if top-level item has a direct url match
  const hasDirectAccess = isTabAllowed(item.url);

  // Filter subItems
  const subItem = item.subItem?.filter(sub => isTabAllowed(sub.link)) || [];

  if (hasDirectAccess || subItem.length > 0) {
    return {
      ...item,
      subItem: subItem.length ? subItem : undefined,
    };
  }

  return null;
}).filter(Boolean);






  // console.log("useDetails",userDetails);
  const handleMenuClick = (label) => {
    setOpenMenu((prevState) => ({
      ...prevState,
      [label]: !prevState[label], // Toggle specific menu's open/close
    }));
  };

  const tToggle = () => {
    const body = document.body;
    if (isMobile) {
      body.classList.add("right-bar-enabled");
    }
    setIsSidebarOpen(!isSidebarOpen);
  };

  const handleResize = () => {
    setIsMobile(window.innerWidth <= 998);
  };

  useEffect(() => {
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    setIsSidebarOpen(true);
    if (window.innerWidth <= 998) {
      document.body.classList.remove("vertical-collpsed");
      document.body.classList.remove("sidebar-enable");
    }
  }, [props.router.location.pathname]);

  useEffect(() => {
    ref.current.recalculate();
  }, []);

  useEffect(() => {
    new MetisMenu("#side-menu-item");
  }, []);

  const activateParentDropdown = useCallback((item) => {
    item.classList.add("active");
    const parent = item.parentElement;
    const parent2El = parent.childNodes[1];
    if (parent2El && parent2El.id !== "side-menu") {
      parent2El.classList.add("mm-show");
    }
    if (parent) {
      parent.classList.add("mm-active");
      const parent2 = parent.parentElement;

      if (parent2) {
        parent2.classList.add("mm-show");
        const parent3 = parent2.parentElement;
        if (parent3) {
          parent3.classList.add("mm-active");
          parent3.childNodes[0].classList.add("mm-active");
          const parent4 = parent3.parentElement;
          if (parent4) {
            parent4.classList.add("mm-show");
            const parent5 = parent4.parentElement;
            if (parent5) {
              parent5.classList.add("mm-show");
              parent5.childNodes[0].classList.add("mm-active");
            }
          }
        }
      }
      scrollElement(item);
      return false;
    }
    scrollElement(item);
    return false;
  }, []);

  const removeActivation = (items) => {
    for (let i = 0; i < items.length; ++i) {
      const item = items[i];
      const parent = item.parentElement;
      if (item && item.classList.contains("active")) {
        item.classList.remove("active");
      }
      if (parent) {
        const parent2El =
          parent.childNodes && parent.childNodes.length && parent.childNodes[1]
            ? parent.childNodes[1]
            : null;
        if (parent2El && parent2El.id !== "side-menu") {
          parent2El.classList.remove("mm-show");
        }
        parent.classList.remove("mm-active");
        const parent2 = parent.parentElement;
        if (parent2) {
          parent2.classList.remove("mm-show");
          const parent3 = parent2.parentElement;
          if (parent3) {
            parent3.classList.remove("mm-active");
            parent3.childNodes[0].classList.remove("mm-active");
            const parent4 = parent3.parentElement;
            if (parent4) {
              parent4.classList.remove("mm-show");
              const parent5 = parent4.parentElement;
              if (parent5) {
                parent5.classList.remove("mm-show");
                parent5.childNodes[0].classList.remove("mm-active");
              }
            }
          }
        }
      }
    }
  };

  const activeMenu = useCallback(() => {
    const pathName = props.router.location.pathname;
    setActivePath(pathName);
    const ul = document.getElementById("side-menu-item");
    const items = ul.getElementsByTagName("a");

    removeActivation(items);

    let matchingMenuItem = null;

    for (let i = 0; i < items.length; ++i) {
      const itemPath = items[i].pathname;
      if (pathName === itemPath || pathName.startsWith(itemPath)) {
        matchingMenuItem = items[i];
        break;
      }
    }

    if (matchingMenuItem) {
      activateParentDropdown(matchingMenuItem);
    }
  }, [props.router.location.pathname, activateParentDropdown]);

  useEffect(() => {
    activeMenu();
  }, [activeMenu]);

  function scrollElement(item) {
    if (item) {
      const currentPosition = item.offsetTop;
      if (currentPosition > window.innerHeight) {
        ref.current.getScrollElement().scrollTop = currentPosition - 300;
      }
    }
  }

  return (
    <React.Fragment>
      <div className={`vertical-menu ${isSidebarOpen ? "" : "vertical-collpsed"}`}>
        {/* <SimpleBar className="h-100" ref={ref}>
          <div id="sidebar-menu">
            <ul className="metismenu list-unstyled" id="side-menu-item">
              {(SidebarData || []).map((item, key) => {
                const isActive = activePath === item.url || activePath.startsWith(item.url);
                const Icon = isActive ? item.iconActive || item.icon : item.icon;

                return (
                  <React.Fragment key={key}>
                    <li className="sidebar-list">
                      <Link to={item.url ? item.url : "/#"} className={item.issubMenubadge || item.isHasArrow ? "" : "has-arrow"}>
                        <div className="menu-item-content" onClick={() => handleMenuClick(item.label)}>
                          <Icon />
                          <span>{props.t(item.label)}</span>
                        </div>
                      </Link>
                      {item.subItem && (
                        <>
                          <button onClick={() => handleMenuClick(item.label)} className="dropdown-toggle">
                            {openMenu?.[item.label] ? (
                              <i className="fas fa-chevron-up"></i> // Up arrow
                            ) : (
                              <i className="fas fa-chevron-down"></i> // Down arrow
                            )}
                          </button>
                          <ul className={`sub-menu ${openMenu?.[item.label] ? "show" : ""}`}>
                            {item.subItem.map((subItem, key) => (
                              <li key={key}>
                                <Link to={subItem.link}>{props.t(subItem.sublabel)}</Link>
                              </li>
                            ))}
                          </ul>
                        </>
                      )}
                    </li>
                  </React.Fragment>
                );
              })}
            </ul>
          </div>
        </SimpleBar> */}
        <SimpleBar className="h-100" ref={ref}>
          <div id="sidebar-menu">
            <ul className="metismenu list-unstyled" id="side-menu-item">
              {/* {SidebarData.map((item, key) => { */}
              {filteredSidebarData.map((item, key) => {

                const isActive = activePath === item.url || activePath.startsWith(item.url);
                const Icon = isActive ? item.iconActive || item.icon : item.icon;

                return (
                  <li className="sidebar-list" key={key}>
                    <div className="menu-item-content" onClick={() => handleMenuClick(item.label)}>
                      <Link to={item.url || "/#"} className="menu-label">
                        <Icon />
                        <span>{props.t(item.label)}</span>
                      </Link>
                      {item.subItem && (
                        <button className="dropdown-toggle">
                          {openMenu?.[item.label] ? (
                            <i className="fas fa-chevron-up"></i> // Up arrow
                          ) : (
                            <i className="fas fa-chevron-down"></i> // Down arrow
                          )}
                        </button>
                      )}
                    </div>
                    {item.subItem && (
                      <ul className={`sub-menu ${openMenu?.[item.label] ? "show" : ""}`}>
                        {item.subItem.map((subItem, key) => (
                          <li key={key}>
                            <Link to={subItem.link}>{props.t(subItem.sublabel)}</Link>
                          </li>
                        ))}
                      </ul>
                    )}
                  </li>
                );
              })}
            </ul>
          </div>
        </SimpleBar>
      </div>

      <style scoped>
        {`
          .sidebar-list a {
            display: flex;
            align-items: center;
          }
          .sidebar-list svg {
            width: 24px;
            height: 24px;
            margin-right: 10px; /* Spacing between icon and label */
          }
          
          .menu-item-content {
            display: flex;
            align-items: center;
            justify-content: space-between;
            width: 100%;
          }

           
            .menu-label {
  white-space: nowrap;  /* Prevent text from wrapping */
  overflow: hidden;      /* Hide overflowing text */
  text-overflow: ellipsis; /* Add "..." to long text */
  max-width: 200px;  /* Adjust based on sidebar width */
}
         .dropdown-toggle {
            background: none;
            border: none;
            cursor: pointer;
            padding: 0;
          }
          .sub-menu {
            display: none;
            padding-left: 20px;
          }
          .sub-menu.show {
            display: block;
          }
            .icon-uniform {
  width: 24px;
  height: 24px;
}
        `}
      </style>
    </React.Fragment>
  );
};

Sidebar.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
};

export default withRouter(withTranslation()(Sidebar));
